import { useTranslation } from 'react-i18next'

import Chip from '@mui/material/Chip'
import { green, orange, red } from '@mui/material/colors'

import type { GiftWithPurchaseCampaignStatus } from '~/promotions/schemas'

type Status = Exclude<GiftWithPurchaseCampaignStatus, 'deleted'>

const STATUS_COLORS: Record<Status, string> = {
    upcoming: orange[800],
    current: green[800],
    expired: red[800],
}

const STATUS_BACKGROUND_COLORS: Record<Status, string> = {
    upcoming: orange[600],
    current: green[600],
    expired: red[600],
}

type Props = {
    status: Status
}

export default function CampaignStatus({ status }: Props) {
    const { t } = useTranslation(['gift_with_purchase'])

    return (
        <Chip
            variant="outlined"
            size="small"
            label={t(`gift_with_purchase_campaign_status.${status}`)}
            sx={{
                cursor: 'default',
                color: STATUS_COLORS[status],
                border: '1px solid',
                borderColor: STATUS_BACKGROUND_COLORS[status],
            }}
        />
    )
}
